import { render, staticRenderFns } from "./ContactInfoPanel.vue?vue&type=template&id=49c7b8fd&scoped=true&"
import script from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoPanel.vue?vue&type=style&index=0&id=49c7b8fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7b8fd",
  null
  
)

export default component.exports